import React, { useCallback, useEffect, useState } from 'react';
import Button from 'src/components/Button/Button';
import { Button as ButtonShad } from 'src/components/ui/button';
import { DialogFooter } from 'src/components/ui/dialog';
import { useAppSelector } from 'src/store';
import { ZendeskChatStep4 } from 'src/pages/ControlDeskPage/IntegrationStatusSection/IntegrationsModal/IntegrationModalStep4/ZendeskChatStep4/ZendeskChatStep4';
import { FreshdeskEmailStep4 } from 'src/pages/ControlDeskPage/IntegrationStatusSection/IntegrationsModal/IntegrationModalStep4/FreshdeskEmailStep4/FreshdeskEmailStep4';
import { ZendeskEmailStep4 } from 'src/pages/ControlDeskPage/IntegrationStatusSection/IntegrationsModal/IntegrationModalStep4/ZendeskEmailStep4/ZendeskEmailStep4';

const NextIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
    <path
      d="M0 5.0625L6.84562 5.0625L3.70125 8.20688L4.5 9L9 4.5L4.5 -9.81574e-10L3.70687 0.793125L6.84562 3.9375L0 3.9375V5.0625Z"
      fill="white"
    />
  </svg>
);
export const IntegrationModalStep4 = ({
  defaultBtnStyle,
  onClick = (_data?: any) => {},
  close = (_isLast?: any) => {},
}: {
  defaultBtnStyle?: boolean;
  onClick?: (data?: any) => void;
  close?: (isLast?: any) => void;
}) => {
  const config = { className: '' };
  const { selectedIntegration } = useAppSelector((s) => s.integrationSlices);
  const [formId, setFormId] = useState('integration-form');
  const isLastStep = selectedIntegration?.setupSteps === 4;

  useEffect(() => {
    if (selectedIntegration) {
      if (selectedIntegration.data.integration_type === 'zendesk_chat') {
        setFormId('auto-setup-form');
      }
      if (selectedIntegration.data.integration_type === 'zendesk_email') {
        setFormId('zendesk-email-step4-form');
      }
      if (selectedIntegration.data.integration_type === 'freshdesk_email') {
        setFormId('freshdesk-email-form');
      }
    }
  }, [selectedIntegration]);

  const renderStep4 = useCallback(() => {
    if (selectedIntegration) {
      switch (selectedIntegration.data.integration_type) {
        case 'zendesk_chat':
          return <ZendeskChatStep4 onClick={onClick} onClose={close} />;
        case 'zendesk_email':
          return <ZendeskEmailStep4 onClick={onClick} onClose={close} />;
        case 'freshdesk_email':
          return <FreshdeskEmailStep4 onClick={onClick} onClose={close} />;
      }
    }
  }, [selectedIntegration]);

  return (
    <>
      {renderStep4()}
      <DialogFooter>
        {!defaultBtnStyle ? (
          <>
            <Button
              style={{ width: 'auto', minWidth: '100px' }}
              className="transparent black"
              onClick={() => close(isLastStep)}
            >
              Cancel
            </Button>
            <Button
              style={{ width: 'auto', minWidth: '100px' }}
              type="submit"
              form="integration-form"
              className={config.className}
            >
              {isLastStep ? (
                'Launch'
              ) : (
                <>
                  Next <NextIcon />
                </>
              )}
            </Button>
          </>
        ) : (
          <div className="sticky bottom-0 w-full">
            <div className="flex w-full items-center justify-center gap-2.5 pb-6 pt-5">
              <ButtonShad
                type="button"
                variant="outline"
                className="transparent black min-w-28"
                onClick={() => close(isLastStep)}
              >
                {isLastStep ? 'Save & Close' : 'Cancel'}
              </ButtonShad>
              <ButtonShad type="submit" className="min-w-28 gap-1.5" form={formId}>
                {isLastStep ? (
                  'Launch'
                ) : (
                  <>
                    Next <NextIcon />
                  </>
                )}
              </ButtonShad>
            </div>
          </div>
        )}
      </DialogFooter>
    </>
  );
};
